<template>
  <app-modal
    v-bind="$attrs"
    title="確認"
    ref="modal"
    class="modal-container"
    content-class="modal-full"
  >
    <template v-slot:body="{ ok, cancel }">
      <v-card-text class="py-4 px-0">
        <div class="modal-body">
          <v-container fluid class="pa-1">
            <div class="font-weight-bold mb-3">
              ポリシーを設定反映します。よろしいですか？
            </div>
            <v-row>
              <v-col cols="6">
                <app-label-group
                  label="回線番号(メイン)"
                  :value="`${type4Service.wnumberMainAct}/${type4Service.wnumberMainSby}[${$filter.enumTo(type4Service.mainSite, 'mainSite')}]`"
                />
              </v-col>
              <v-col cols="6">
                <app-label-group
                  label="回線番号(BCP)"
                  :value="`${type4Service.wnumberBcpAct}/${type4Service.wnumberBcpSby}[${$filter.enumTo(type4Service.mainSite === 'TOKYO' ? 'OSAKA' : 'TOKYO', 'mainSite')}]`"
                />
              </v-col>
              <v-col cols="12">
                <app-label-group
                  label="VPN/VNコード"
                  :value="
                    type4Service.vpnVnCode.charAt(0) !== 'B'
                      ? `${type4Service.vpnVnCode}(${type4Service.vnName})`
                      : type4Service.vpnVnCode
                  "
                />
              </v-col>
              <v-col cols="12">
                <app-label-group label="Type" value="インターネットType4" />
              </v-col>
              <v-col cols="12">
                <app-label-group
                  label="Type4ID"
                  :value="type4Service.type4Id"
                />
              </v-col>
              <v-col cols="12">
                <app-label-group
                  label="Type4名"
                  :value="type4Service.type4Name"
                />
              </v-col>
              <v-col cols="12">
                <app-label-group
                  label="メインサイト"
                  :value="$filter.enumTo(type4Service.mainSite, 'mainSite')"
                />
              </v-col>
              <v-col cols="12">
                <app-label-group label="セキュリティアプライアンス">
                  <template #value>
                    <span class="ml-3">
                      <template v-if="type4Service.applianceType === 'IFW'">
                        インターネットFW(100Mbpsベストエフォート)
                      </template>
                      <template
                        v-if="
                          type4Service.applianceType === 'UTM' &&
                          type4Service.contractType === 'BEST_EFFORT'
                        "
                      >
                        UTM(1Gbpsベストエフォート)
                      </template>
                      <template
                        v-if="
                          type4Service.applianceType === 'UTM' &&
                          type4Service.contractType === 'SECURING'
                        "
                      >
                        UTM(帯域確保型{{
                          $filter.bandwidthTo(type4Service.bandwidth!)
                        }})
                      </template>
                    </span>
                  </template>
                </app-label-group>
              </v-col>
              <v-col cols="12">
                <app-label-group
                  label="状態"
                  :value="$filter.enumTo(type4Service.status, `status`)"
                />
              </v-col>
            </v-row>
            <div class="font-weight-bold mt-4">
              アクセス拠点 → インターネット
            </div>
            <div class="mt-2 text-subtitle-2">NAT(IP Masquerade)</div>
            <v-table density="compact">
              <thead class="v-table-head text-caption">
                <tr>
                  <th>ID</th>
                  <th>送信元アドレス</th>
                  <th>宛先アドレス</th>
                  <th>IP Pool</th>
                  <th>有効/無効</th>
                  <th>備考</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in type4Policy.policyIPMasqueradeType4!
                    .policyList"
                  :key="item.policyId"
                  :class="{
                    'gray-out':
                      item.policyCategoryInfo === 'UNEDITABLE_DEFAULT_POLICY',
                  }"
                >
                  <td>{{ item.policyId }}</td>
                  <td>
                    <policy-src-address
                      :src-address="{ srcAddressList: item.srcAddressList }"
                    />
                  </td>
                  <td>
                    <policy-dst-address
                      :dst-address="{ dstAddressList: item.dstAddressList }"
                    />
                  </td>
                  <td>
                    <policy-ip-pool :ip-pool-list="item.ipPoolList" />
                  </td>
                  <td>
                    {{ $filter.enumTo(item.isPolicyStatus, "enable") }}
                  </td>
                  <td class="text-pre-wrap">
                    {{ $filter.emptyTo(item.description, "-") }}
                  </td>
                </tr>
              </tbody>
            </v-table>

            <div class="mt-2 text-subtitle-2">UTM</div>
            <v-table density="compact">
              <thead class="v-table-head text-caption">
                <tr>
                  <th>ID</th>
                  <th>送信元アドレス</th>
                  <th>宛先アドレス</th>
                  <th>サービス</th>
                  <th>プロファイル</th>
                  <th>アクション</th>
                  <th>ログ出力</th>
                  <th>有効/無効</th>
                  <th>備考</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in type4Policy.policyUtmType4!
                    .accessPointToInternetPolicyList"
                  :key="item.policyId"
                  :class="{
                    'gray-out':
                      item.policyCategoryInfo === 'UNEDITABLE_DEFAULT_POLICY',
                  }"
                >
                  <td>{{ item.policyId }}</td>
                  <td>
                    <policy-src-address :src-address="item.srcAddress" />
                  </td>
                  <td>
                    <policy-dst-address :dst-address="item.dstAddress" />
                  </td>
                  <td>
                    <policy-service
                      :service-option="item.serviceOption"
                      :default-service-list="item.defaultServiceList"
                      :custom-service-list="item.customServiceList"
                    />
                  </td>
                  <td>
                    <policy-profile :profile="item.profile" />
                  </td>
                  <td>
                    {{ $filter.enumTo(item.actionType, "allow_deny") }}
                  </td>
                  <td>
                    {{ $filter.enumTo(item.isLogOutput, "on_off") }}
                  </td>
                  <td>
                    {{ $filter.enumTo(item.isPolicyStatus, "enable") }}
                  </td>
                  <td class="text-pre-wrap">
                    {{ $filter.emptyTo(item.description, "-") }}
                  </td>
                </tr>
              </tbody>
            </v-table>

            <div class="font-weight-bold mt-4">
              インターネット → アクセス拠点
            </div>
            <div class="mt-3 text-subtitle-2">NAT(IP Forwarding)</div>
            <v-table density="compact">
              <thead class="v-table-head text-caption">
                <tr>
                  <th>ID</th>
                  <th>送信元アドレス</th>
                  <th>IPマッピング</th>
                  <th>有効/無効</th>
                  <th>備考</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in type4Policy.policyNatType4!.policyList"
                  :key="item.policyId"
                >
                  <td>{{ item.policyId }}</td>
                  <td>
                    <policy-src-address
                      :src-address="{ srcAddressList: item.srcAddressList }"
                    />
                  </td>
                  <td>
                    {{ item.ipMapping ? item.ipMapping.ipMappingName : "-" }}
                  </td>
                  <td>
                    {{ $filter.enumTo(item.isPolicyStatus, "enable") }}
                  </td>
                  <td class="text-pre-wrap">
                    {{ $filter.emptyTo(item.description, "-") }}
                  </td>
                </tr>
              </tbody>
            </v-table>

            <div class="mt-3 text-subtitle-2">UTM</div>
            <v-table density="compact">
              <thead class="v-table-head text-caption">
                <tr>
                  <th>ID</th>
                  <th>送信元アドレス</th>
                  <th>宛先アドレス</th>
                  <th>サービス</th>
                  <th>プロファイル</th>
                  <th>アクション</th>
                  <th>ログ出力</th>
                  <th>有効/無効</th>
                  <th>備考</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in type4Policy.policyUtmType4!
                    .internetToAccessPointPolicyList"
                  :key="item.policyId"
                  :class="{
                    'gray-out':
                      item.policyCategoryInfo === 'UNEDITABLE_DEFAULT_POLICY',
                  }"
                >
                  <td>{{ item.policyId }}</td>
                  <td>
                    <policy-src-address :src-address="item.srcAddress" />
                  </td>
                  <td>
                    <policy-dst-address :dst-address="item.dstAddress" />
                  </td>
                  <td>
                    <policy-service
                      :service-option="item.serviceOption"
                      :default-service-list="item.defaultServiceList"
                      :custom-service-list="item.customServiceList"
                    />
                  </td>
                  <td>
                    <policy-profile :profile="item.profile" />
                  </td>
                  <td>
                    {{ $filter.enumTo(item.actionType, "allow_deny") }}
                  </td>
                  <td>
                    {{ $filter.enumTo(item.isLogOutput, "on_off") }}
                  </td>
                  <td>
                    {{ $filter.enumTo(item.isPolicyStatus, "enable") }}
                  </td>
                  <td class="text-pre-wrap">
                    {{ $filter.emptyTo(item.description, "-") }}
                  </td>
                </tr>
              </tbody>
            </v-table>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn color="primary" variant="flat" @click="ok">はい</v-btn>
            <v-btn color="primary" variant="outlined" @click="cancel"
              >いいえ
            </v-btn>
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { GetPolicyType4 } from "@/apis/NwPolicyApi";
import PolicySrcAddress from "@/components/policy/PolicySrcAddress.vue";
import PolicyDstAddress from "@/components/policy/PolicyDstAddress.vue";
import PolicyService from "@/components/policy/PolicyService.vue";
import PolicyProfile from "@/components/policy/PolicyProfile.vue";
import type { Type4Service } from "@/apis/ContractChangeType4Api";
import PolicyIpPool from "@/components/policy/PolicyIpPool.vue";
import AppLabelGroup from "@/components/AppLabelGroup.vue";

export default defineComponent({
  name: "InternetType4PolicyUtmConfirm",
  components: {
    AppLabelGroup,
    PolicyIpPool,
    PolicyProfile,
    PolicyService,
    PolicyDstAddress,
    PolicySrcAddress,
  },
  props: {
    /** type4ポリシー全体 */
    type4Policy: {
      type: Object as PropType<GetPolicyType4>,
      required: true,
    },
    /** サービスメニュー(インターネットType4) */
    type4Service: {
      type: Object as PropType<Type4Service>,
      required: true,
    },
  },
});
</script>
<style lang="scss" scoped>
th {
  text-align: center !important;
}
td {
  min-width: 60px !important;
}
</style>
